import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar";
import { processedInvoiceQueries } from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import InvoiceAddressNotEditableMessage
	from "~/modules/billing/components/InvoiceDetailsView/components/UpdateInvoiceAddressSidebar/InvoiceAddressNotEditableMessage.tsx";
import UpdateInvoiceAddressForm
	from "~/modules/billing/components/InvoiceDetailsView/components/UpdateInvoiceAddressSidebar/UpdateInvoiceAddressForm.tsx";
import { processedStatuses } from "~/modules/billing/utils/billingUtils.ts";

type Props = {
	invoiceData: Invoice;
	isOpen: boolean;
	onClose: () => void;
};

const UpdateInvoiceAddressSidebar = ({
	invoiceData,
	isOpen,
	onClose,
}: Props) => {
	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: processedInvoiceQueries.details(invoiceData.id).queryKey });
		onClose();
	}, [invoiceData.id, onClose, queryClient]);

	const invoiceIsEditable = !processedStatuses.includes(invoiceData.invoiceStatusId);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && !invoiceIsEditable && <InvoiceAddressNotEditableMessage onCancel={onClose} />}
			{isOpen && invoiceIsEditable && <UpdateInvoiceAddressForm address={invoiceData.address}
																	  buyerEAddress={invoiceData.buyerEAddress}
																	  invoiceId={invoiceData.id}
																	  recipientLegalName={invoiceData.recipientLegalName}
																	  onCancel={onClose}

																	  onSuccess={handleSuccess} />}
		</Sidebar>
	);
};

export default UpdateInvoiceAddressSidebar;
